/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

/* eslint-disable @typescript-eslint/no-explicit-any */

export const ACTIONS = {
  tap: 'tap',
  click: 'click',
  view: 'screen_view',
};
